module.exports = __webpack_public_path__ + "static/icons/icon-lock-8ec7b6a0056c39bccde1c19240dfe9ef.svg";